// extracted by mini-css-extract-plugin
export default {"container":"Box_container__sY0ET","title":"Box_title__jlUel","body":"Box_body__Co++l","noWrap":"Box_noWrap__V1nFO"};